<section class="register-user__transport-means-field">
  <header class="transport-means-field__header">
    <h3 class="transport-means-field__title ci-heading-h2-s-bold">
      {{ 'Mis transportes' | translate }}
    </h3>
    
    @if(isInvalidField()) {
      <mat-error class="ci-paragraph-p1-regular">
        {{ 'Mínimo selecciona un medio de transporte' | translate }}
      </mat-error>
    } @else {
      <span class="ci-paragraph-p1-regular transport-means-field__helper-text">
        {{ 'Selecciona como mínimo un medio de transporte para realizar tu ruta' | translate }}
        <strong> ({{ 'obligatorio' | translate }})</strong>
      </span>
    }
  </header>

  <main>
    <ci-chip-set 
      multiselect
      (change)="handleChipSetTransportMeansChange($event)"
    >
      @for(transport of transportMeans; track transport.id; let i = $index) {
        <ci-filter-chip-outline
          class="register-user__transport-mean"
          [chip]="transport"
          [attr.icon-name]="transport.iconName"
          [value]="transport.value"
          [attr.data-value]="transport.value"
          [attr.data-eco]="transport.eco"
          [attr.data-selected]="isSelectedTransportMean(transport.value)"
          [selected]="isSelectedTransportMean(transport.value)"
        >
          <span slot="label">
            {{ transport.label | translate }}
          </span>
        </ci-filter-chip-outline>
      }
    </ci-chip-set>
  </main>  
</section>